import React, { useState, useEffect } from 'react';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import '../styles/SectionConnexion.scss';
import envelope from '../assets/envelope.svg';
import cadena from '../assets/cadena.svg';
import google from '../assets/iconGoogle.svg';
import useUserSession from './useUserSession';
import { saveSession } from './sessionManager';
import { useTranslation } from 'react-i18next';

function GroupingConnexion({ handleClick, handleConnectWithGoole, handleForgotPassword, onLoginSuccess, googleError, setGoogleError }) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showError, setShowError] = useState('');
  const { setUser } = useUserSession();
  const { t } = useTranslation();

  // Auto-dismiss des erreurs après 5s
  useEffect(() => {
    if (showError) {
      const timer = setTimeout(() => setShowError(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [showError]);

  useEffect(() => {
    if (googleError) {
      const timer = setTimeout(() => setGoogleError(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [googleError, setGoogleError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    switch (name) {
      case 'email':
        if (emailRegex.test(value)) {
          if (!!errors[name]) {
            delete errors[name];
          }
        } else {
          errors[name] = t('auth.invalidEmail');
        }
        break;
      case 'password':
        if (value.length > 0) {
          if (!!errors[name]) {
            delete errors[name];
          }
        } else {
          errors[name] = t('auth.passwordEmpty');
        }
        break;
      default:
        if (!!errors[name]) {
          delete errors[name];
        }
        break;
    }
    setErrors({ ...errors });
  };

  const validateForm = () => {
    let formErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) {
      formErrors.email = t('auth.emailRequired');
    } else if (!emailRegex.test(formData.email)) {
      formErrors.email = t('auth.invalidEmailAddress');
    }

    if (!formData.password) {
      formErrors.password = t('auth.passwordRequired');
    }

    return formErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setIsSubmitting(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/signin`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        const result = await response.json();
        if (response.ok) {
          if (result.status === 0) {
            setShowError('');
            saveSession({ uid: result.user._id, email: result.user.email, name: result.user.name, token: result.token, state: 1 });
            setUser({ uid: result.user._id, email: result.user.email, name: result.user.name, token: result.token, state: 1 });
            if (onLoginSuccess) onLoginSuccess();
          } else {
            setShowError(result.message);
            setFormData({
              email: '',
              password: '',
            });
          }
        }
      } catch (error) {
        setShowError(t('auth.networkError'));
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div className='GroupingConnexion'>
      {(showError || googleError) && (
        <div className='GroupingConnexionErrors'>
          <span>{showError || googleError}</span>
          <button type='button' onClick={() => { setShowError(''); if (setGoogleError) setGoogleError(''); }}>✕</button>
        </div>
      )}
      <h4>
        <span>{t('auth.enterCredentials')}</span>
        <span>{t('auth.ofConnection')}</span>
      </h4>
      <div>
        <Form className='modal-body-form' onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="email">
            <FloatingLabel controlId="floatingInput" label={t('auth.email')} className="mb-3">
              <span className='form-floating-blueMagic'></span>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                isInvalid={!!errors.email}
              />
              <img src={envelope} alt='envelope' />
              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <Form.Group className="mb-3" controlId="password">
            <FloatingLabel controlId="floatingPassword" label={t('auth.password')}>
              <span className='form-floating-blueMagic'></span>
              <Form.Control
                type="password"
                placeholder="Password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                isInvalid={!!errors.password}
              />
              <img src={cadena} alt='cadena' />
              <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <Button type="submit" disabled={isSubmitting}>
            {!isSubmitting ? <span>{t('auth.connection')}</span> : <span className="spinner-border text-light" role="status"></span>}
          </Button>
        </Form>
      </div>
      <div className='forgotPassword'>
        <span onClick={handleForgotPassword}>{t('auth.forgotPassword')}</span>
      </div>
      <p>{t('auth.orConnectWith')}</p>
      <div className='reseauSociaux'>
        <div className='reseauSociaux1' onClick={handleConnectWithGoole}>
          <img src={google} alt='google' />
        </div>
      </div>
      <div className='queryConnexion'>
        <span className='queryConnexion1'>{t('auth.noAccount')}</span>
        <span className='queryConnexion2' onClick={handleClick}>{t('auth.createHere')}</span>
      </div>
    </div>
  );
}

export default GroupingConnexion;
